import React from 'react';

import AnchorActivityItem from '../AnchorActivityItem/AnchorActivityItem';
import CreatedTaskItem from '../CreatedTaskItem/CreatedTaskItem';

const CreatedItem = (props) => {
  const { title, filename, onClickFile, newValue, tagTypeId } = props;
  const isTask = title?.includes('task');

  if (!isTask) {
    return (
      <AnchorActivityItem
        actionTypeLabel={` ${title || 'uploaded'}`}
        filename={filename}
        onClickFile={onClickFile}
      />
    );
  }

  return <CreatedTaskItem actionTypeLabel={` ${title}`} title={newValue} taskId={tagTypeId} />;
};

export default CreatedItem;
